<template>
    <table class="table table-sm table-hover custom_table">
        <thead class="custom_thead">
            <tr>
                <th>셀 번호</th>
                <th>셀 전압</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, index) in items" :key="index" @click="locationSelected(index)">
                <td>{{ index + 1}}</td>
                <td>{{ item  }}</td>
            </tr>
            <tr>
                <td colspan="6" class="text-center" v-show="items.length === 0"> 셀 전압 데이터가 없습니다. </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default: []
        }
    },

    data() {
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
.custom_table {
  border-collapse: separate;
  border-spacing: 0;
  font-size: 12px;
  text-align: center;

  thead tr th {
    background-color: #F5FAFF;
    border-color: #F5FAFF;
    padding: 5px 10px;
  }

  thead tr:first-child {
    th:first-child {
      border-left: 1px solid #F5FAFF;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    th:last-child {
      border-right: 1px solid #F5FAFF;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }

  tbody {
    td {
      border-top: 0px;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;
      max-width: 180px;
      vertical-align: middle;
    }

    tr:last-child td {
      border-bottom: 0px solid #f0f0f0;
    }
  }

}
</style>